/**
 * Datos de mercado: Keywords "centro de rehabilitación" en Chile.
 * Fuente: Keyword Surfer (junio 2026) — sinadicciones.org/marketing-centros-rehabilitacion
 *
 * NOTA: Estos datos son estáticos (snapshot). Si Keyword Surfer actualiza
 * los volúmenes, refrescar este archivo cada 6 meses.
 */

export const MARKET_OVERVIEW = {
  totalVolume: 27650,        // búsquedas/mes en Chile relacionadas
  totalKeywords: 4260,
  avgKD: 17,                  // 0-100, menor = más fácil rankear
  avgCPC: 0.34,               // USD (lo que pagarías por click en Google Ads)
  lastUpdated: '2026-06-07',
};

/**
 * Top keywords por volumen mensual.
 * KD: Keyword Difficulty (0-100), menor = más fácil rankear.
 * intent: I=Informacional · C=Comercial · T=Transaccional · N=Navegacional
 */
export const TOP_KEYWORDS = [
  { kw: 'centro de rehabilitación',                       vol: 5400, kd: 35, cpc: 0.34, intent: 'C', city: null },
  { kw: 'centro de rehabilitación de drogas',             vol: 2900, kd: 23, cpc: 0.34, intent: 'C', city: null },
  { kw: 'centro de rehabilitación de drogas gratis',      vol: 1000, kd: 25, cpc: 0.45, intent: 'I', city: null },
  { kw: 'centro de rehabilitación teletón',               vol: 1000, kd: 37, cpc: 0.28, intent: 'N', city: null },
  { kw: 'centro de rehabilitación infantil ejército CRIE', vol: 590,  kd: 16, cpc: 0.00, intent: 'I', city: null },
  { kw: 'centro de rehabilitación Santiago',              vol: 590,  kd: 30, cpc: 0.38, intent: 'C', city: 'Santiago' },
  { kw: 'centro de rehabilitación de drogas gratis Santiago', vol: 480, kd: 14, cpc: 0.20, intent: 'I', city: 'Santiago' },
  { kw: 'centro de rehabilitación de drogas precios Chile', vol: 480, kd: 16, cpc: 0.38, intent: 'T', city: null },
  { kw: 'centro de rehabilitación Punta Arenas',          vol: 480,  kd: 33, cpc: 0.20, intent: 'N', city: 'Punta Arenas' },
  { kw: 'centro de rehabilitación Talagante',             vol: 320,  kd: 28, cpc: 0.18, intent: 'N', city: 'Talagante' },
  { kw: 'rehabilitación de drogas',                       vol: 720,  kd: 22, cpc: 0.30, intent: 'I', city: null },
  { kw: 'centro de rehabilitación de mujeres',            vol: 260,  kd: 19, cpc: 0.22, intent: 'C', city: null },
  { kw: 'comunidad terapéutica chile',                    vol: 210,  kd: 24, cpc: 0.18, intent: 'I', city: null },
  { kw: 'centro de rehabilitación de alcohol',            vol: 390,  kd: 21, cpc: 0.31, intent: 'C', city: null },
  { kw: 'centro de rehabilitación Concepción',            vol: 170,  kd: 26, cpc: 0.24, intent: 'C', city: 'Concepción' },
];

/**
 * Top temas (clusters de keywords). Suma de búsquedas mensuales por término.
 */
export const KEYWORD_THEMES = [
  { theme: 'drogas',         keywords: 729, monthlyVol: 11200 },
  { theme: 'chile',          keywords: 293, monthlyVol: 4800 },
  { theme: 'alcohol',        keywords: 250, monthlyVol: 3100 },
  { theme: 'comunitaria',    keywords: 224, monthlyVol: 1900 },
  { theme: 'santiago',       keywords: 159, monthlyVol: 2400 },
  { theme: 'gratis',         keywords: 123, monthlyVol: 1800 },
  { theme: 'drogadicto',     keywords: 114, monthlyVol: 970 },
  { theme: 'gratuito',       keywords: 108, monthlyVol: 1100 },
  { theme: 'concepción',     keywords: 77,  monthlyVol: 580 },
];

/**
 * Demanda por ciudad/región (estimada a partir de keywords geo-locales).
 */
export const DEMAND_BY_CITY = [
  { city: 'Santiago (RM)',  monthlyVol: 2400, opportunity: 'Alta' },
  { city: 'Concepción',     monthlyVol: 580,  opportunity: 'Media-Alta' },
  { city: 'Punta Arenas',   monthlyVol: 480,  opportunity: 'Media' },
  { city: 'Talagante',      monthlyVol: 320,  opportunity: 'Media' },
  { city: 'Valparaíso',     monthlyVol: 280,  opportunity: 'Media-Alta' },
  { city: 'La Serena',      monthlyVol: 210,  opportunity: 'Media' },
  { city: 'Temuco',         monthlyVol: 190,  opportunity: 'Media' },
  { city: 'Antofagasta',    monthlyVol: 170,  opportunity: 'Media' },
];

/**
 * Preguntas long-tail reales que hacen los usuarios.
 * Estas son las que un buen blog debería responder.
 */
export const LONGTAIL_QUESTIONS = [
  { q: '¿A quién atiende un centro de rehabilitación?',                  topic: 'awareness' },
  { q: '¿Es rentable un centro de rehabilitación?',                       topic: 'b2b' },
  { q: '¿Es rentable un centro de rehabilitación de drogas?',             topic: 'b2b' },
  { q: '¿Para qué sirve un centro de rehabilitación?',                    topic: 'awareness' },
  { q: '¿A quién atiende centro de rehabilitación Capredena?',            topic: 'navegacional' },
  { q: '¿Cuánto cuesta un centro de rehabilitación en Chile?',            topic: 'transaccional' },
  { q: '¿Cómo elegir un centro de rehabilitación?',                       topic: 'consideration' },
];

/**
 * Tips accionables de marketing para centros.
 * Si tienes un artículo publicado que cubra el tema, ponlo en `articleSlug`.
 */
export const MARKETING_TIPS = [
  {
    number: 1,
    title: 'Optimiza tu Google Business Profile',
    description:
      'El 70% de las búsquedas "centro de rehabilitación + ciudad" muestran el Local Pack de Google. Sin GBP optimizado, eres invisible. Sube fotos reales, responde reseñas y publica novedades semanales.',
    icon: 'Search',
    articleSlug: 'google-business-profile-para-centros-de-rehabilitación--guía-paso-a-paso',
  },
  {
    number: 2,
    title: 'Posiciona tu página de tratamientos',
    description:
      'La página de "Tratamientos" es el corazón de tu sitio. Si no rankea, todo el resto del marketing es ruido. Estructura el contenido, agrega FAQs con Schema.org y enlaza desde el menú principal.',
    icon: 'TrendingUp',
    articleSlug: 'como-posicionar-pagina-de-tratamientos-en-tu-sitio-web',
  },
  {
    number: 3,
    title: 'Estrategia de redes sociales especializada',
    description:
      'El marketing en redes para tratamiento de adicciones exige un enfoque distinto: ética, sensibilidad, contenido educativo y comunidad — no promoción agresiva. Esta guía te muestra qué publicar y qué evitar.',
    icon: 'HelpCircle',
    articleSlug: 'estrategia-de-redes-sociales-para-tratamiento-de-adicciones-2026',
  },
  {
    number: 4,
    title: 'Únete a un directorio especializado',
    description:
      'Estar en SinAdicciones.org te da SEO compartido, trust score B2C y leads matcheados por modalidad. Cada uno de los 207 centros registrados gana ~3-15 leads/mes en función del plan.',
    icon: 'Building2',
    articleSlug: 'directorio-de-centros-de-rehabilitación-en-chile--visibilidad-para-centros',
  },
  {
    number: 5,
    title: 'Mide el éxito de tu marketing digital',
    description:
      'Muchos centros invierten en web, redes y anuncios pero no saben qué funciona. Sin KPIs claros (CTR, conversión, CAC, LTV), estás quemando presupuesto a ciegas. Esta guía te muestra qué medir cada semana.',
    icon: 'Star',
    articleSlug: 'cómo-medir-el-éxito-del-marketing-digital-en-tu-centro-de-rehabilitación-',
  },
  {
    number: 6,
    title: 'Diseño mobile-first',
    description:
      '83% de las búsquedas en Chile son móviles. Si tu sitio carga >3 segundos o no se ve bien en celular, pierdes 60% de las llamadas. Mide en PageSpeed Insights y apunta a Core Web Vitals verdes.',
    icon: 'Smartphone',
    articleSlug: null,
  },
  {
    number: 7,
    title: 'Email marketing post-consulta',
    description:
      'El 75% de las personas que piden información NO ingresa la primera semana. Un drip email de 5 correos durante 14 días te convierte 3x más. Resend + Omnisend integran fácil con tu CRM.',
    icon: 'Mail',
    articleSlug: null,
  },
];

/**
 * FAQ B2B (al final de la landing).
 */
export const B2B_FAQ = [
  {
    q: '¿Cuánto cuesta estar en SinAdicciones.org?',
    a: 'Tenemos un plan Gratuito (perfil básico, aparece en el directorio) y 3 planes pagos: Destacado ($99.000 CLP/mes, Top 11-20), Premium ($199.000 CLP/mes, Top 4-10) y Elite ($350.000 CLP/mes, Top 1-3, máximo 6 por región y 2 por modalidad). Ver detalle completo en /planes.',
  },
  {
    q: '¿Cómo recibo los leads?',
    a: 'Te llegan por email, WhatsApp y aparecen en tu panel en /panel. Cada lead incluye: nombre, teléfono, sustancia consumida, ubicación, contexto y urgencia. El primer contacto en tomar el teléfono típicamente cierra el caso.',
  },
  {
    q: '¿Hay permanencia mínima o compromiso?',
    a: 'No. Todos los planes son mes a mes. Puedes cancelar cuando quieras desde tu panel sin penalización. Ofrecemos descuento por pago trimestral o anual si quieres congelar el precio actual.',
  },
  {
    q: '¿Cómo me destaco frente a otros centros de mi ciudad?',
    a: 'Con el plan Elite reservado (máximo 6 por región, 2 por modalidad) tienes 24h de exclusividad sobre los leads + badge Top 1-3 + foto destacada + posicionamiento prioritario en buscador interno y matching.',
  },
  {
    q: '¿Aceptan centros de cualquier modalidad?',
    a: 'Sí. Aceptamos residenciales, ambulatorios, mixtos, online y comunidades terapéuticas. Pedimos verificación: razón social, RUT, ubicación física verificable y al menos un profesional clínico responsable (psicólogo/psiquiatra titulado).',
  },
  {
    q: '¿Entregan reportes mensuales?',
    a: 'Sí. Cada plan recibe reporte el día 1 de cada mes: leads recibidos, tasa de contacto, distribución por modalidad/sustancia, ranking de visibilidad y comparativo con el mes anterior. El panel también muestra datos en tiempo real.',
  },
  {
    q: '¿Cómo protegen los datos de los pacientes?',
    a: 'Cumplimos la Ley 19.628 (Protección de la vida privada). Los datos se almacenan agregados/anonimizados para fines estadísticos. El consentimiento es explícito en cada formulario antes de compartir información con un centro.',
  },
];

export const INTENT_LABEL = {
  I: { label: 'Informacional', color: 'text-blue-400 bg-blue-500/10 border-blue-500/30' },
  C: { label: 'Comercial',     color: 'text-amber-400 bg-amber-500/10 border-amber-500/30' },
  T: { label: 'Transaccional', color: 'text-emerald-400 bg-emerald-500/10 border-emerald-500/30' },
  N: { label: 'Navegacional',  color: 'text-violet-400 bg-violet-500/10 border-violet-500/30' },
};
